import { APP_BASE_HREF, CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { ApButtonComponent } from '@ap/button';
import { ApContentPipe } from '@ap/content';
import { ApDarkmodeModule } from '@ap/darkmode';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApInputComponent } from '@ap/input';
import { ApNotificationComponent } from '@ap/notification';

import { PairingCodeResource } from '../pairing-code/pairing-code.resource';

// @ts-expect-error: error needs to be ignored so the typescript compiler replaces BASE_HREF
export const baseHref: string = BASE_HREF;

@NgModule({
    imports: [
        ApButtonComponent,
        ApContentPipe,
        ApDarkmodeModule,
        ApIllustrationComponent,
        ApInputComponent,
        ApNotificationComponent,
        BrowserModule,
        CommonModule,
        ReactiveFormsModule
    ],
    exports: [
        ApButtonComponent,
        ApContentPipe,
        ApDarkmodeModule,
        ApIllustrationComponent,
        ApInputComponent,
        ApNotificationComponent,
        ReactiveFormsModule
    ],
    providers: [
        PairingCodeResource,
        {
            provide: APP_BASE_HREF,
            useValue: baseHref
        },
        Location,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }
    ]
})
export class KoppelcodeInvoerenModule {}
